export const MuiInputLabel = (palette) => ({
  styleOverrides: {
    root: {
      fontFamily: "'Roboto', sans-serif",
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '20px',
      color: palette.text.primary,
      transform: 'none',
      top: '-4px',
    },
  },
});
